import { Link } from "react-router-dom";
import { Logo } from "@/components/brand/logo";

export function MarketingFooter() {
  return (
    <footer className="relative z-10 border-t border-ink-200/70 bg-white">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 px-6 py-8 text-xs text-ink-500 sm:flex-row lg:px-12">
        <div className="flex items-center gap-3">
          <Logo tone="dark" size="sm" to="/" />
          <span>© {new Date().getFullYear()} Ustorio</span>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
          <a href="/#ozellikler" className="hover:text-ink-900">
            Özellikler
          </a>
          <a href="/#nasil-calisir" className="hover:text-ink-900">
            Nasıl çalışır
          </a>
          <a href="/#sss" className="hover:text-ink-900">
            SSS
          </a>
          <Link to="/hakkimizda" className="hover:text-ink-900">
            Hakkımızda
          </Link>
          <Link to="/blog" className="hover:text-ink-900">
            Blog
          </Link>
          <Link to="/contact" className="hover:text-ink-900">
            İletişim
          </Link>
          <Link to="/login" className="hover:text-ink-900">
            Giriş
          </Link>
        </div>
      </div>
    </footer>
  );
}
